import { IconAlertCircle } from '@tabler/icons-react';

export function ProfileSelectorError() {
  return (
    <div className="px-3 py-4 text-center">
      <IconAlertCircle size={32} className="text-danger mb-2" />
      <p className="text-secondary mb-0 small">Nie udało się załadować profili</p>
    </div>
  );
}
